import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	stroke: "#000000",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0 1.714C0 1.241.384.857.857.857h22.286a.857.857 0 0 1 0 1.714H.857A.857.857 0 0 1 0 1.714Zm0 5.143C0 6.384.384 6 .857 6H18a.857.857 0 1 1 0 1.714H.857A.857.857 0 0 1 0 6.857ZM0 12c0-.473.384-.857.857-.857h12a.857.857 0 1 1 0 1.714h-12A.857.857 0 0 1 0 12Zm0 10.286c0-.474.384-.857.857-.857h22.286a.857.857 0 0 1 0 1.714H.857A.857.857 0 0 1 0 22.286Zm0-5.143c0-.474.384-.857.857-.857H18A.857.857 0 0 1 18 18H.857A.857.857 0 0 1 0 17.143Z",
		fill: "#000",
		fillRule: "evenodd",
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20stroke%3D%22%23000000%22%3E%3Cpath%20d%3D%22M0%201.714C0%201.241.384.857.857.857h22.286a.857.857%200%200%201%200%201.714H.857A.857.857%200%200%201%200%201.714Zm0%205.143C0%206.384.384%206%20.857%206H18a.857.857%200%201%201%200%201.714H.857A.857.857%200%200%201%200%206.857ZM0%2012c0-.473.384-.857.857-.857h12a.857.857%200%201%201%200%201.714h-12A.857.857%200%200%201%200%2012Zm0%2010.286c0-.474.384-.857.857-.857h22.286a.857.857%200%200%201%200%201.714H.857A.857.857%200%200%201%200%2022.286Zm0-5.143c0-.474.384-.857.857-.857H18A.857.857%200%200%201%2018%2018H.857A.857.857%200%200%201%200%2017.143Z%22%20fill%3D%22%23000%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
